import { Skeleton } from "@mui/material";

const LockedGridCell = () => <Skeleton animation={false} variant="rounded" height={12} width="75%" />;

export default LockedGridCell;
